newsHandler = {
    $newsContent : $('.news-content-container'),
    $newsItem : $('.news-content-item'),
    $moreButton : $('[href="#more-news"]'),
    $yearItem : $('.year-filter-item'),
    $newsContainer : $('.news-container'),
    $search : $('#search-news'),
    $categories : $('select#categories'),
    $year : $('select#year'),
    
    searchNewsViews() {
        var self = this;
        
        let year        = self.$year.find(":selected").val();
        let categories  = self.$categories.find(":selected").val();
        let search      = self.$search.val().trim();
        let newURLParam = '';
        
        if (year) 
            newURLParam     = (newURLParam ? '&' : '?') + 'filter-year=' + year; 

        if (categories) 
            newURLParam     += (newURLParam ? '&' : '?') + 'filter-categories=' + categories; 

        if (search) 
            newURLParam     += (newURLParam ? '&' : '?') + 'filter-search=' + search; 

        $.ajax({
            type: 'post',
            url: myAjax.ajax_url,
            data: {
                action: 'load_news',
                year: year,
                search: search,
                category: categories,
                is_featured: false,
            },
            beforeSend: function() {
                $('.news-container').find('.panel-news-content').addClass('loading-container');
            },
            success: function(response) {
                var $resultHtml = response['html'];

                $('.news-container').find('.main-news-content').replaceWith($resultHtml);
                $('.news-container').find('.panel-news-content').removeClass('loading-container');
                
                newURLParam = window.location.origin + window.location.pathname + newURLParam;
                window.history.pushState("News & Views", "News & Views", newURLParam);
            }
        });
    },

    init : function() {
        var self = this;

        $('body').on('click', '[href="#more-news"]', function(e) {
            e.preventDefault();

            var counter = 6;

            self.$newsContainer.find('.news-content-item.hide').each(function() {
                if (counter != 0) {
                    $(this).removeClass('hide');
                    counter--;
                }
            });

            if (self.$newsContainer.find('.news-content-item.hide').length == 0 ) {
                $(this).addClass('hide');
            }
        });

        if (Foundation.MediaQuery.only('small')) {
            $('body').on('click', '.news-content-item', function(e) {
                if ($(this).hasClass('is-showing')) {
                    $(this).removeClass('is-showing')
                } else {
                    $(this).addClass('is-showing')
                }
            });
        }

        $(document).on('click', ".btn-search-news", function(){
            // if ($(this).hasClass('icon-clear')) {
            //     $(this).prev().val('');
            // }
            self.searchNewsViews();            
        })

        $(document).on('change', "select#categories, select#year", function(){
            self.searchNewsViews();            
        })

        $(document).on('keyup', 'input#search-news', function(e){
            /*
            let val = $(this).val().trim();
            if (val !== '') {
                $(this).next().removeClass('icon-search').addClass('icon-clear');
            } else {
                $(this).next().removeClass('icon-clear').addClass('icon-search');
            }*/

            if (e.keyCode == 13) {
                self.searchNewsViews();
            }
        })
    }
}